
export const TX_FILTERS = ['All', 'Credits', 'Debits', 'Pending', 'Cleared'];

export const WALLET_USERS = [
  { name: 'James Whitfield', email: 'j.whitfield@apexfin.com', initials: 'JW', role: 'Admin', permissions: ['View', 'Send', 'Approve'], active: true, bg: 'linear-gradient(135deg,#1f2937,#374151)' },
  { name: 'Sarah Chen', email: 's.chen@apexfin.com', initials: 'SC', role: 'Manager', permissions: ['View', 'Send'], active: true, bg: 'linear-gradient(135deg,#f59e0b,#d97706)' },
  { name: 'Marco Delgado', email: 'm.delgado@apexfin.com', initials: 'MD', role: 'Viewer', permissions: ['View'], active: true, bg: 'linear-gradient(135deg,#10b981,#059669)' },
  { name: 'Priya Kapoor', email: 'p.kapoor@apexfin.com', initials: 'PK', role: 'Manager', permissions: ['View', 'Send', 'Approve'], active: false, bg: 'linear-gradient(135deg,#9ca3af,#6b7280)' },
];

export const MOCK_TRANSACTIONS = [
  { date: 'Feb 20', desc: 'ACH - Vendor X', type: 'Debit', amount: '-$15,000.00', status: 'Cleared', isDebit: true },
  { date: 'Feb 19', desc: 'Wire - Tech Corp', type: 'Credit', amount: '+$250,000.00', status: 'Received', isDebit: false },
  { date: 'Feb 18', desc: 'RTP & FedNow Payment', type: 'Credit', amount: '+$5,000.00', status: 'Processed', isDebit: false },
  { date: 'Feb 17', desc: 'ACH - Vendor X', type: 'Debit', amount: '-$15,000.00', status: 'Cleared', isDebit: true },
  { date: 'Feb 16', desc: 'RTP & FedNow - Client', type: 'Credit', amount: '+$5,000.00', status: 'Processed', isDebit: false },
  { date: 'Feb 15', desc: 'ACH Payment', type: 'Debit', amount: '-$15,000.00', status: 'Cleared', isDebit: true },
  { date: 'Feb 14', desc: 'Wire - Tech Corp', type: 'Credit', amount: '+$250,000.00', status: 'Received', isDebit: false },
  { date: 'Feb 13', desc: 'RTP & FedNow - Client', type: 'Credit', amount: '+$5,000.00', status: 'Processed', isDebit: false },
];

export const MARKET_DATA = [
  { name: 'Bitcoin', ticker: 'BTC/USD', value: '$94,210.50', change: '+2.3%', up: true },
  { name: 'Ethereum', ticker: 'ETH/USD', value: '$3,480.25', change: '+1.1%', up: true },
  { name: 'EUR/USD', ticker: 'Forex', value: '1.0850', change: '-0.2%', up: false },
  { name: 'NASDAQ', ticker: 'Composite', value: '19,580.25', change: '+0.75%', up: true },
];

export const ACCOUNT_DETAILS = {
  cross_border: {
    USD: { account: '123-456-789', routing: '987-654-321', type: 'Fedwire / ACH' },
    EUR: { iban: 'ES12 3456 7890 1234 5678', bic: 'NYBAESMMXXX', type: 'SEPA / SWIFT' }
  },
  business: {
    USD: { account: '987-654-321', routing: '123-456-789', type: 'Fedwire / ACH' },
    EUR: { iban: 'ES12 9876 5432 1098 7654', bic: 'NYBAESMMXXX', type: 'SEPA / SWIFT' }
  },
};

export const MOCK_TRANSACTIONS_EUR = [
  { date: 'Feb 20', desc: 'SEPA Credit - Partner AG', type: 'Credit', amount: '+€42,000.00', status: 'Processed', isDebit: false },
  { date: 'Feb 18', desc: 'SEPA Debit - Utilities SL', type: 'Debit', amount: '-€1,250.00', status: 'Cleared', isDebit: true },
  { date: 'Feb 15', desc: 'SWIFT - Global Logistics', type: 'Credit', amount: '+€185,000.00', status: 'Received', isDebit: false },
  { date: 'Feb 12', desc: 'SEPA Debit - SaaS License', type: 'Debit', amount: '-€850.00', status: 'Cleared', isDebit: true },
  { date: 'Feb 10', desc: 'SEPA Credit - Tax Refund', type: 'Credit', amount: '+€5,120.00', status: 'Processed', isDebit: false },
];

export const STMT_MONTHS = [
  'February 2026', 'January 2026', 'December 2025', 'November 2025',
  'October 2025', 'September 2025', 'August 2025', 'July 2025',
  'June 2025', 'May 2025', 'April 2025', 'March 2025',
];
